import { Component, OnInit, OnDestroy } from "@angular/core";
//import { Subscription } from 'rxjs';

import * as moment from "moment"; // Needed For moment.preciseDiff() to work
import { PreciseDiff } from "../shared/precise-diff";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";

import { DataService_viewlog } from "./shared/data.service";

import { wsFacilityByUserIDListInfo } from "./shared/wsFacilityByUserIDListInfo";
import { wsVPPAdminVisitorLogListParm } from "./shared/wsVPPAdminVisitorLogListParm";
import { wsVPPAdminVisitorLogListInfo } from "./shared/wsVPPAdminVisitorLogListInfo";

import { PrintVisitorsLogComponent } from "./printvisitorslog/printvisitorslog.component";

import { ViewChild } from "@angular/core";
import { DataService_viewvisitordetail } from "../viewvisitordetail/shared/data.service";

//
// Needed For moment.preciseDiff() to work
//
// declare module "moment" {
// 	function preciseDiff(start: string | Date | moment.Moment, end: string | Date | moment.Moment, convertToObject?: boolean): any;
// }

@Component({
	selector: "app-root",
	templateUrl: "./viewlog.component.html",
	styleUrls: ["./viewlog.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ViewLogComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterVisitorLogStatusDesc", { static: false })
	public filterVisitorLogStatusDesc: Dropdown;
	@ViewChild("filterEntryFacilityLocation", { static: false })
	public filterEntryFacilityLocation: Dropdown;
	@ViewChild("filterDestinationFacilityLocation", { static: false })
	public filterDestinationFacilityLocation: Dropdown;
	@ViewChild("filterFacilityName", { static: false })
	public filterFacilityName: Dropdown;

	constructor(
		private dataService: DataService_viewlog,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private ViewVisitorDetail: DataService_viewvisitordetail
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	Facility Selector
	public lstFacility: wsFacilityByUserIDListInfo[] = [];
	public SelectedFacility: wsFacilityByUserIDListInfo;

	//	DateRange Selector
	public lstDateRange: any = [];
	public SelectedDateRange: any;

	//	Visitor Log List
	public lstVisitorLog: wsVPPAdminVisitorLogListInfo[] = [];
	public SelectedVisitorLog: wsVPPAdminVisitorLogListInfo;

	//	Filters
	public lstVisitorLogStatusDescs: any = [];
	public lstEntryFacilityLocations: any = [];
	public lstDestinationFacilityLocations: any = [];
	public lstFacilityNames: any = [];

	//	Facility Location Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	public StartDate: Date = new Date();
	public EndDate: Date = new Date();

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//
		//	Set DateRange Selector
		//
		this.lstDateRange = [
			{ DateRangeID: 1, DateRangeDesc: "Today", LastXMonths: 0 },
			{ DateRangeID: 2, DateRangeDesc: "Last Month", LastXMonths: 1 },
			{ DateRangeID: 3, DateRangeDesc: "Last 2 Months", LastXMonths: 2 },
			{ DateRangeID: 4, DateRangeDesc: "Last 3 Months", LastXMonths: 3 },
			{
				DateRangeID: 5,
				DateRangeDesc: "Custom Date Range",
				LastXMonths: -1,
			},
		];

		this.SelectedDateRange = this.lstDateRange[0];

		//
		//	Populate Visitor Log List
		//
		this.isBusy = true;
		this.ErrorMessage = "";
		this.dataService.FacilityByUserIDSelectList(this.user.userID).subscribe((data) => this.FacilityByUserIDSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityByUserIDSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityByUserIDSelectList_Complete(data: any) {
		this.SelectedVisitorLog = null;
		this.lstFacility = data;

		//
		//	Add the [- ALL -] to the top of the list
		//
		//	Note: "- ALL" is put in FacilityCD to match the HTML formatting.
		//		this allows it to show with a visual appeal that matches the rest of the items.
		//
		this.lstFacility.unshift({
			FacilityID: -1,
			FacilityCD: "- ALL",
			FacilityName: "",
		});

		this.SelectedFacility = this.lstFacility[0];
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterVisitorLogStatusDesc.clear(null);
		this.filterFacilityName.clear(null);
		this.filterDestinationFacilityLocation.clear(null);
		this.filterEntryFacilityLocation.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		let StartDateParm = new Date();
		StartDateParm.setHours(0, 0, 0, 0); // Clear Hours

		let EndDateParm = new Date();
		EndDateParm.setHours(0, 0, 0, 0); // Clear Hours

		this.ErrorMessage = "";

		if (this.SelectedDateRange.DateRangeID == 5) {
			// Custom Date Range
			if (this.StartDate == null) {
				this.ErrorMessage = "Invalid Start Date";
				return;
			} else {
				StartDateParm = this.StartDate;
				StartDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.EndDate == null) {
				this.ErrorMessage = "Invalid End Date";
				return;
			} else {
				EndDateParm = this.EndDate;
				EndDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.StartDate > this.EndDate) {
				this.ErrorMessage = "Start Date cannot be greater than End Date";
				return;
			}

			//
			//	Greater Than 1 Year Check when ALL facilities are selected
			//
			if (this.SelectedFacility.FacilityID == -1 && this.EndDate > this.StartDate) {
				let DayDiff = PreciseDiff.preciseDiff(this.StartDate, this.EndDate, true);

				if (DayDiff.years > 1 || (DayDiff.years == 1 && (DayDiff.months > 0 || DayDiff.days > 0))) {
					this.ErrorMessage = "Date range must be less then 1 year when ALL facilities are selected.";
					return;
				}
			}
		}

		let parms: wsVPPAdminVisitorLogListParm = {
			UserID: this.user.userID,
			FacilityID: this.SelectedFacility.FacilityID,
			LastXMonths: this.SelectedDateRange.LastXMonths,
			StartDate: StartDateParm,
			EndDate: EndDateParm,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorLogSelectList(parms).subscribe((data) => this.VPPAdminVisitorLogSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorLogSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorLogSelectList_Complete(data: any) {
		this.SelectedVisitorLog = null;
		this.lstVisitorLog = data;

		//
		//	Clear Detail Data
		//
		this.ViewVisitorDetail.VisitorLogSelected(-1);

		//
		//	Set Filter Lists
		//
		this.lstVisitorLogStatusDescs = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.VisitorLogStatusDesc)));
		this.lstEntryFacilityLocations = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.EntryFacilityLocation)));
		this.lstDestinationFacilityLocations = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.DestinationFacilityLocation)));
		this.lstFacilityNames = Array.from(new Set(this.lstVisitorLog.map((item: any) => item.FacilityName)));

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "FacilityName", order: 1 });
		this.mydt.multiSortMeta.push({ field: "logDT", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		//
		//	Display Print Popup
		//
		var ref = this.dialogService.open(PrintVisitorsLogComponent, {
			header: "Print",
			width: "435px",
			data: {
				UserPersonID: this.user.personID,
				UserID: this.user.userID,
				FacilityID: this.SelectedFacility.FacilityID,
				DateRangeID: this.SelectedDateRange.DateRangeID,
				StartDate: this.StartDate,
				EndDate: this.EndDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {
		this.ViewVisitorDetail.VisitorLogSelected(this.SelectedVisitorLog.VisitorLogID);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedFacilityLocation here. We don't unselect when selected.
		//
		this.SelectedVisitorLog = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFacilityChange(value) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDateRangeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onDateRangeChange(value) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDateChange(val) {
		this.StartDate = val;
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDateChange(val) {
		this.EndDate = val;
		this.onRefresh();
	}
	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
